import React from 'react';
import { IconButton, makeStyles } from '@material-ui/core';
import { useWizard } from "react-use-wizard"
import CloseIcon from "@material-ui/icons/Close";

export const Header = ({ onClose, title }) => {
    const { activeStep, stepCount } = useWizard()
    const styles = useStyles()

    return (
        <div className={styles.root}>
            <span className={styles.title}>{title}</span>
            <span>{activeStep + 1} / {stepCount}</span>
            <div className={styles.btn}>
                <IconButton aria-label="close" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </div>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: "18px",
        paddingBottom: "18px",
        padding: "18px 40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: theme.border,
    },
    title: {
        width: 150
    },
    btn: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: 150
    }
}))